/**
 * Ordered step configuration for the banking transition flow.
 * Each step declares its route segment, its clickstream page name, and `next()` /
 * `previous()` resolvers so navigation never hardcodes paths. Phase 3.5 inserts `mailing-address` before
 * `banking-options` and `mercury` after it.
 */
export const BANKING_TRANSITION_SEGMENT = 'transition';

export const BANKING_TRANSITION_PAGE_NAMES = Object.freeze({
  BANKING_OPTIONS: 'banking_transition_banking_options'
});

export const BANKING_TRANSITION_STEPS = Object.freeze([
  {
    path: 'banking-options',
    pageName: BANKING_TRANSITION_PAGE_NAMES.BANKING_OPTIONS,
    previous: () => null,
    next: () => null
  }
]);
